import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63dcf0ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-el" }
const _hoisted_2 = { class: "my-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "bg-light p-5 width-700" }
const _hoisted_8 = {
  class: "d-flex flex-column px-2",
  id: "kt_modal_assign_user_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_assign_user_header",
  "data-kt-scroll-wrappers": "#kt_modal_assign_user_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_10 = { class: "fv-row mb-3" }
const _hoisted_11 = { class: "fs-6 required mb-2" }
const _hoisted_12 = { class: "fv-plugins-message-container text-start" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-md-12 fv-row mt-0" }
const _hoisted_15 = { class: "fv-row mb-3" }
const _hoisted_16 = { class: "fs-6 required mb-2" }
const _hoisted_17 = { class: "fv-plugins-message-container text-start" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "mt-2 d-flex justify-content-between" }
const _hoisted_20 = {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      id: "kt_modal_assign_user_form",
      onSubmit: _ctx.submit,
      ref: "formRef",
      class: "form mw-650px",
      "validation-schema": _ctx.siteUserValidationSchema
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.modelValueProp,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValueProp) = $event)),
          "show-close": false,
          "close-on-click-modal": false,
          "close-on-press-escape": false
        }, {
          header: _withCtx(({ close, titleId, titleClass }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h4", {
                id: titleId,
                class: _normalizeClass(titleClass)
              }, [
                _createTextVNode(_toDisplayString(_ctx.t("pages.site.assignUser")) + " ", 1),
                _createElementVNode("a", {
                  onClick: _withModifiers(
                  () => {
                    close();
                    _ctx.$emit('update:modelValue', false);
                  }
                , ["stop"]),
                  class: "float-end me-n4"
                }, _hoisted_6, 8, _hoisted_4)
              ], 10, _hoisted_3)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"])),
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
              }, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.t("common.save")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate("common.users")), 1),
                    _createVNode(_component_Field, {
                      name: "userAccountId",
                      modelValue: _ctx.siteUserTargetData['userAccountId'],
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.siteUserTargetData['userAccountId']) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_VZMultiSelect, {
                          name: "userAccountId",
                          modelValue: _ctx.siteUserTargetData['userAccountId'],
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.siteUserTargetData['userAccountId']) = $event)),
                          element: {
                      options: _ctx.userOptions,
                      multiSelect: true,
                      placeholder: _ctx.translate('pages.user.selectUser'),
                    }
                        }, null, 8, ["modelValue", "element"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "userAccountId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate("common.roles")), 1),
                    _createVNode(_component_Field, {
                      name: "userRoleId",
                      modelValue: _ctx.siteUserTargetData.userRoleId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.siteUserTargetData.userRoleId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.siteUserTargetData.userRoleId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.siteUserTargetData.userRoleId) = $event)),
                          placeholder: "Please select role",
                          filterable: "",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (option, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: option.label,
                                value: option.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, { name: "userRoleId" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}